import PropTypes from 'prop-types';
import cx from 'classnames';
import InfoText from '../InfoText';
import RadioField from '../common/fields/RadioField';
import InputField from '../common/fields/InputField';
import style from '../styles.module.scss';
import { useTranslation } from 'react-i18next';

const NoteItem = ({
  noteKey,
  name,
  oldNotesRadioId,
  newNotesRadioId,
  value,
  translationNotes
}) => {
  const { t } = useTranslation();
  const notes = [
    {
      inputLabel: 'OLD_NOTE',
      id: oldNotesRadioId,
      name: name,
      value: value.oldNotesVal,
      key: noteKey
    },
    {
      inputLabel: 'NEW_NOTE',
      id: newNotesRadioId,
      name: name,
      value: value.newNotesVal,
      key: noteKey
    }
  ];

  const noteName = {
    title: t(translationNotes),
    className:
      'u-color--DarkGray u-fs--14 text-univers--bold fw-bold border-bottom'
  };
  return (
    <div className={cx('mb-1', style['note__field-container'])}>
      <InfoText data={noteName} />
      <div className="row">
        {notes.map(item => (
          <div className="col-md-6" key={item.id}>
            <RadioField item={item} />
            <InputField item={item} />
          </div>
        ))}
      </div>
    </div>
  );
};

NoteItem.propTypes = {
  noteKey: PropTypes.string,
  value: PropTypes.shape({
    oldNotesVal: PropTypes.string,
    newNotesVal: PropTypes.string
  }),
  name: PropTypes.string,
  oldNotesRadioId: PropTypes.string,
  newNotesRadioId: PropTypes.string,
  translationNotes: PropTypes.string
};

export default NoteItem;
